import { Transform, Type } from 'class-transformer';
import {
	calendarDateTransformer,
	dateTransformer,
} from 'src/lib/utilities/api/class-transformer-types';
import {
	PagingSearchFieldArgument,
	PagingSearchFieldArrayArgument,
} from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';
import { PagingArgument } from 'src/lib/utilities/api/patterns/pagination/paging.argument';

export type CourseRegistrationType = 'Standard' | 'Persistent' | 'Undefined';

export enum CertificationState {
	NotApplicable = 'not_applicable',
	NotDue = 'not_due',
	Blocked = 'blocked',
	AwaitingStudent = 'awaiting_student',
	Certified = 'certified',
}

export class CourseRegistrationModel {
	registration_id: number;
	student_uid: number | null;
	student_name: string | null;
	section_id: number | null;
	section_name: string | null;
	course_id: number | null;
	course_name: string | null;
	term: string | null;
	registration_type: CourseRegistrationType;
	@Transform(dateTransformer)
	created_timestamp: Date;
	@Transform(dateTransformer)
	started_timestamp: Date | null;
	@Transform(calendarDateTransformer)
	pacing_start_date: Date | null;
	@Transform(dateTransformer)
	pacing_end_timestamp: Date | null;
	@Transform(dateTransformer)
	completed_timestamp: Date | null;
	@Transform(dateTransformer)
	counted_timestamp: Date | null;
	days_in_class: number | null;
	final_grade: string | null;
	teacher_uid: number | null;
	teacher_name: string | null;
	percent_submitted: number | null;
	ungraded_assignments: number | null;
	has_final: boolean | null;
	final_submitted: boolean | null;
	institute_id: number | null;
	program_title: string | null;
	program_type: string | null;
	program_state: string | null;
	lms_registration_link: string | null;
	certification_status: CertificationState | null;
	certified_hours: number | null;
}

export function CourseRegistrationModel_ClassTransform_Type() {
	return CourseRegistrationModel;
}

export class CourseRegistrationsResponseModel {
	count: number;
	@Type(CourseRegistrationModel_ClassTransform_Type)
	items: CourseRegistrationModel[];
}

export interface CourseRegistrationsSearchFilters {
	student_uid: PagingSearchFieldArgument;
	student_name: PagingSearchFieldArgument;
	section_id: PagingSearchFieldArgument;
	section_name: PagingSearchFieldArgument;
	course_id: PagingSearchFieldArgument;
	course_name: PagingSearchFieldArgument;
	term: PagingSearchFieldArrayArgument;
	registration_type: PagingSearchFieldArgument<CourseRegistrationType>;
	created_timestamp: PagingSearchFieldArgument;
	started_timestamp: PagingSearchFieldArgument;
	pacing_start_date: PagingSearchFieldArgument;
	pacing_end_timestamp: PagingSearchFieldArgument;
	completed_timestamp: PagingSearchFieldArgument;
	counted_timestamp: PagingSearchFieldArgument;
	days_in_class: PagingSearchFieldArgument;
	final_grade: PagingSearchFieldArgument;
	teacher_uid: PagingSearchFieldArgument;
	teacher_name: PagingSearchFieldArgument;
	percent_submitted: PagingSearchFieldArgument;
	ungraded_assignments: PagingSearchFieldArgument;
	has_final: PagingSearchFieldArgument<boolean>;
	final_submitted: PagingSearchFieldArgument<boolean>;
	institute_id: PagingSearchFieldArgument;
	program_title: PagingSearchFieldArgument;
	program_type: PagingSearchFieldArgument;
	program_state: PagingSearchFieldArgument;
	certification_status: PagingSearchFieldArrayArgument;
	certified_hours: PagingSearchFieldArgument;
}

export interface CourseRegistrationsSearchArgument extends PagingArgument<CourseRegistrationsSearchFilters> {
	group: string;
	created_from: string;
	created_to: string;
}

export class CourseTimeCertification {
	assignment_hours: number;
	lesson_hours: number;
	logged_hours: number;
	state: CertificationState;
	total_hours: number;
}
